<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0

@component
Shows a little popup in case of errors or warning

-->
<script>
import { snackbarStore } from '../../utils/SnackbarStore';
import uiStore from '../../utils/UIStore';

function closeSnackbar() {
  snackbarStore.update((current) => ({ ...current, snackbarOpen: false, snackbarAction: null }));
}

function confirmAction() {
  snackbarStore.update((current) => {
    if (current.snackbarAction) current.snackbarAction();
    return { ...current, snackbarOpen: false, snackbarAction: null };
  });
}

//load ui texts from ui Store
let uiTexts;
uiStore.textStore.subscribe((store) => {
  uiTexts = store.texts;
});
</script>

{#if $snackbarStore.snackbarOpen}
	<div class="snackbar {$snackbarStore.snackbarSeverity}" role="alert">
	  {$snackbarStore.snackbarMessage}
	  {#if $snackbarStore.snackbarSeverity === "confirmation"}
		<div style="display:flex; margin-top: 20px;">
            <button style="margin-right: 20px;" on:click={confirmAction}>{uiTexts.confirm}</button>
            <button on:click={closeSnackbar}>{uiTexts.cancel}</button>
		</div>
    	{:else}
            <button style="margin-left: 10px;" on:click={closeSnackbar}>✕</button>
        {/if}
	</div>
{/if}

<style>
	.snackbar {
		position: fixed;
		top: 30%;
		left: 50%;
		transform: translateX(-50%);
		background: #fff;
		color: #333;
		border: 1px solid #bbb;
		border-radius: 6px;
		padding: clamp(1rem, 5vw, 2.5rem) clamp(1rem, 8vw, 3rem);
		z-index: 1000;
		box-shadow: 0 2px 8px rgba(0,0,0,0.08);
		font-size: clamp(1rem, 2vw, 1.2rem);
		white-space: pre-line;
	}
	.snackbar.error,
	.snackbar.confirmation {
		background: #ffeaea;
		border-color: #e53935;
		color: #b71c1c;
	}
	.snackbar.success {
		background: #eafaf1;
		border-color: #4caf50;
		color: #2e7d32;
	}
	.snackbar.error,
	.snackbar.success {
		display: flex;
		align-items: flex-start;
		gap: 10px;
	}

</style>
